import React, { useEffect, useState } from 'react';
import { IoMdCloseCircle } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import { Input } from '@material-ui/core';

import api from '@/Services/api';

import StyledButton from '@/Components/Buttons';
import HeaderEditable from '@/Components/HeaderEditable';

import {
  Container,
  Farm,
  FormLogin,
  FarmsContainer,
  MigrationBanner,
} from './styles';

const legacyUrl = 'https://legado.agrosti.com.br';
const isLegacyHost = window.location.hostname === 'legado.agrosti.com.br';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [farms, setFarms] = useState([]);
  const [formDisplay, setFormDisplay] = useState('none');
  const [activeFarm, setActiveFarm] = useState('');
  const [error, setError] = useState(false);

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');

  const history = useHistory();

  useEffect(() => {
    if (!isLegacyHost) return;

    getFarms();
  }, []);

  async function getFarms() {
    const { data } = await api.get('/Login');

    if (data && data instanceof Array) setFarms(data);
  }

  function setDisplayBlock(farm) {
    setFormDisplay('block');
    setActiveFarm(farm);
  }

  function setDisplayNone() {
    setFormDisplay('none');
  }

  async function handleSubmit(event) {
    try {
      setIsLoading(true);
      event.preventDefault();

      localStorage.setItem('user', user);

      const data = {
        userLogin: user,
        password,
        farmName: activeFarm,
      };

      const response = await api.post('Login', data);

      if (!response.data) {
        setIsLoading(false);
        setError(true);
      } else {
        setIsLoading(false);
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('farmName', activeFarm);
        localStorage.setItem('logo', response.data.logo);
        history.push('/Farm');
      }
    } catch (error) {
      setError(true);
    }
  }

  if (!isLegacyHost) {
    return (
      <Container>
        <MigrationBanner>
          <strong>O Portal mudou de endereço.</strong>
          <span>Acesse o sistema legado pelo novo link oficial:</span>
          <a href={legacyUrl}>legado.agrosti.com.br</a>
        </MigrationBanner>
      </Container>
    );
  }

  return (
    <Container>
      <HeaderEditable />
      <FarmsContainer>
        {(farms || []).map((farm) => (
          <Farm key={String(farm.fazenda)} className="farms">
            <h3>{farm.fazenda}</h3>
            <img src={farm?.logo} alt="logo" />
            <StyledButton
              onClick={() => setDisplayBlock(farm.fazenda)}
            >
              Entrar
            </StyledButton>
          </Farm>
        ))}
      </FarmsContainer>
      <FormLogin
        display={formDisplay}
        onSubmit={handleSubmit}
        error={error}
      >
        <IoMdCloseCircle onClick={setDisplayNone} />
        <h3>{activeFarm.toUpperCase()}</h3>

        <Input
          required
          placeholder="Usuário"
          autoComplete="off"
          onChange={(event) => {
            setUser(event.target.value);
            setError(false);
          }}
        />
        <Input
          required
          placeholder="Senha"
          autoComplete="off"
          type="password"
          onChange={(event) => {
            setPassword(event.target.value);
            setError(false);
          }}
        />

        <StyledButton disabled={isLoading} type="submit" >Entrar</StyledButton>
      </FormLogin>
    </Container>
  );
};

export default Login;
